import _ from 'lodash';
import React from 'react';
import styled from 'styled-components';
import { Margin, Padding, Queue, Stack, Text } from '../../components';
import { BenefitsAndPerksData } from './shared';

const IconWrapper = styled.div`
  height: 100%;
  vertical-align: top;
`;

export const BenefitsAndPerksComponentMobile = (props) => {
  let { value, align } = props;
  let { icon, title, description } = value || {
    icon: '',
    title: '',
    description: '',
  };
  return (
    <Queue size={5} height="100%">
      <IconWrapper>{icon}</IconWrapper>
      <Stack>
        <Text align={align} textType="primary1">
          {title}
        </Text>
        <Text align={align} textType="primary2">
          {description}
        </Text>
      </Stack>
    </Queue>
  );
};

export const BenefitsAndPerksMobile = () => {
  return (
    <Padding size={[6]} backgroundRole="grey2">
      <Stack size={7}>
        <Margin size={[5, 0, 0, 0]}>
          <Text textType="heading3">Benefits & Perks</Text>
        </Margin>
        <Stack size={7}>
          {_.flow((BenefitsAndPerksData) =>
            _.map(BenefitsAndPerksData, (value, index) => {
              return (
                <BenefitsAndPerksComponentMobile
                  value={value}
                  align="left"
                  key={index}
                />
              );
            })
          )(BenefitsAndPerksData)}
        </Stack>
      </Stack>
    </Padding>
  );
};
